import React from 'react'
import {AbsoluteCenter, Form, FormRow, FormField, FormTitle} from './StyledComponents'
import {TextField, Paper, RaisedButton} from 'material-ui'
import validator from "validator"
import {MANAGE_PROCUREMENTS} from '../routes'
import {hasTokenFromLocalStorage} from './../helpers/token'
class Login extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			username: {
				value: '',
				errorText: ''
			},
			password: {
				value: '',
				errorText: ''
			}
		};
	}

	handleInputChange = (event, value) => {
		const target = event.target;
		const name = target.name;
		var errorText = this.validate(name, value);
		this.setState({
			[name]: {value: value, errorText: errorText}
		});
	}

	validate = (fieldName, value) => {
		if(fieldName === 'username') {
			if(validator.isEmpty(value)) {
				return 'This field is required.';
			}
		}
		if(fieldName === 'password') {
			if(validator.isEmpty(value)) {
				return 'This field is required.';
			}
		}
		return '';
	}

	render() {
		const {login, history} = this.props
		if(hasTokenFromLocalStorage()) {
			history.push(MANAGE_PROCUREMENTS)
		}
		return (
			<AbsoluteCenter>
				<Paper>
				<Form>
					<FormTitle>WMSU BAC Login</FormTitle>
					<FormRow>
					<FormField>
						<TextField 
							name="username"
							floatingLabelFixed={true}
							floatingLabelText="Username"
							onChange={this.handleInputChange}
							value={this.state.username.password}
							errorText={this.state.username.errorText}
							autoFocus={true}
						/>
					</FormField>
					<FormField>
						<TextField 
							name="password"
							floatingLabelFixed={true}
							floatingLabelText="Password"
							onChange={this.handleInputChange}
							value={this.state.password.value}
							errorText={this.state.password.errorText}
							type="password"
						/>
					</FormField>
					</FormRow>
					<FormRow>
						<FormField>
							<RaisedButton 
								label="Login" 
								primary={true} 
								onTouchTap={() => {
									let data = {
										username: this.state.username.value,
										password: this.state.password.value,
									}
									let hasError = false;
									for (var property in data) {
										if (data.hasOwnProperty(property)) {
											var errorText = this.validate(property, data[property]);
											if(errorText !== '') {
												hasError = true;
												this.setState({
													[property]: {value: data[property], errorText: errorText}
												});
												break;
											}
										}
									}
									if(hasError === false) {
										login(data).then(() => {
											history.push(MANAGE_PROCUREMENTS)
										})
										
									}
								}}/>
						</FormField>
					</FormRow>
				</Form>
				</Paper>
			</AbsoluteCenter>
		)
	}
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.js